// extracted by mini-css-extract-plugin
export var image = "ch_c5";